import {
  REVIEW_ACTIVE_ORDER_NOTES_TEXT,
  REVIEW_SPECIAL_INSTRUCTIONS_TEXT,
} from 'components/Modals/QCBulkPassFailModal';
import { Button, Grid, Tooltip } from '@mui/material';
import { SubmittingIcon } from 'components/icons/LoadingIcon';
import React from 'react';
import { checkIfFailedQC } from 'components/Modals/QCPassFailModal/utilities';
import { useAppContext } from 'services/context';

export const QCPassFailModalActions = ({
  classes,
  slide,
  handleNextSlide,
  handlePreviousSlide,
  qcChecks,
  selectedRows,
  handleSubmit,
  isSubmitting,
  isSpecialInstructionsChecked,
  isActiveOrderNotes,
  isActiveOrderNotesChecked,
}) => {
  const { setModalQCPassFailOpen } = useAppContext();

  let submitLabel;
  let buttonStyle;

  const qc_failed = checkIfFailedQC(qcChecks);

  if (!qc_failed) {
    submitLabel = 'QC PASSED';
    buttonStyle = classes.passedQCButton;
  } else {
    submitLabel = 'QC FAILED';
    buttonStyle = classes.failedQCButton;
  }

  let submitTooltipTitle = REVIEW_SPECIAL_INSTRUCTIONS_TEXT;

  if (isSpecialInstructionsChecked) {
    submitTooltipTitle = REVIEW_ACTIVE_ORDER_NOTES_TEXT;

    if (isActiveOrderNotes && isActiveOrderNotesChecked) {
      submitTooltipTitle = '';
    }
  }

  const selectedRowsUUIDs = selectedRows.map(({ uuid }) => uuid);
  const currentSelectedLocation = selectedRowsUUIDs.indexOf(slide.uuid);
  const previousDisabled = currentSelectedLocation === 0;
  const nextDisabled = currentSelectedLocation === selectedRows.length - 1;

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      wrap="nowrap"
      className={classes.dialogActionsWrapper}
    >
      <Grid item container alignItems="center">
        <Grid item>
          <Button
            variant="contained"
            color={'primary'}
            onClick={handlePreviousSlide}
            disabled={previousDisabled}
          >
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color={'secondary'}
            onClick={handleNextSlide}
            disabled={nextDisabled}
            marginLeft={1}
          >
            Next
          </Button>
        </Grid>
      </Grid>
      <Grid item container justifyContent="flex-end" alignItems="center">
        <Grid item marginRight={1}>
          <Button
            color="primary"
            onClick={() => setModalQCPassFailOpen(prev => !prev)}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Tooltip title={submitTooltipTitle}>
            <span>
              <Button
                variant="contained"
                color="secondary"
                className={buttonStyle}
                onClick={handleSubmit}
                disabled={
                  isSubmitting ||
                  !isSpecialInstructionsChecked ||
                  (isActiveOrderNotes && !isActiveOrderNotesChecked)
                }
              >
                <SubmittingIcon submitting={isSubmitting} size={10} />
                {submitLabel}
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};
